var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDokumente(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 24",
    style: {
      enableBackground: "new 0 0 20 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.7,0H2.5C1.1,0,0,1.1,0,2.5V24h20V7.3L12.7,0z M13,1.7L18.3,7H13C13,7,13,1.7,13,1.7z M15,23H5H1V2.5 C1,1.7,1.7,1,2.5,1H12v7h7v15H15z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDokumente);
export default __webpack_public_path__ + "static/media/Dokumente.d50b5717d8879d74f2fa9840a1b7dfe4.svg";
export { ForwardRef as ReactComponent };